export { CACHED_HEADER, ONLINE_HEADER } from './lib/classes/cached-request';
export { PaceOfflineModule } from './lib/pace-offline.module';
export { OfflineInterceptorService } from './lib/service/offline-interceptor.service';
export { FileStorageOfflineStrategyService } from './lib/service/offline-strategies/file-storage-offline-strategy.service';
export { IndexeddbOfflineStrategyService } from './lib/service/offline-strategies/indexeddb-offline-strategy.service';
export { OfflineService } from './lib/service/offline.service';
export { removeRequestFromQueue } from './lib/store/actions/request-queue.actions';
export { PaceOfflineFeatureState } from './lib/store/state';
export { initialCacheInfoState } from './lib/store/types/cache-info.state';
export { initialCacheState } from './lib/store/types/cache.state';
export { initialRefreshRequestQueueState } from './lib/store/types/refresh-request-queue.state';
export { initialRequestQueueState } from './lib/store/types/request-queue.state';
export { OnlineDetectorInjectionToken } from './lib/interfaces/online-detector.interface';
